import { getEnv } from "@ace/env";

export type TradingPairMeta = {
  initialPrice: string;
  maximumOrderValue: string;
  minimumOrderValue: string;
  tickSize: string;
};

export type AltTradingPair = {
  id: number;
  ticker: string;
  baseAssetId: number;
  quoteAssetId: number;
  priceInCents: number;
  priceDecimalPlaces: number;
  status: "Created" | "Suspended" | "Terminated" | "Trading" | "Pre-Live";
  description: string;
  externalId: number;
  productId: number;
  meta: TradingPairMeta;
};

export const getAllTradingPairs = async (): Promise<AltTradingPair[]> => {
  const response = await fetch(
    `${getEnv(
      "VITE_ACE_WEB_AUTH_SERVER",
    )}/rest-gateway/reporting/trading-pairs`,
    {
      method: "GET",
    },
  );
  const json = await response.json();

  if (json.status === "ERROR") {
    throw new Error(json.error[0].msg);
  }

  const data = json.data as AltTradingPair[];

  return data;
};
